import React from 'react';
import { Box } from '@tanium/react-box';
import styled from '@tanium/react-emotion';
import { css } from '@tanium/style-system';
import { ThemeFontWeights } from '@tanium/theme-data';
import { BodyFooterDivider, HeadingFill, HeadingText, SubHeadingText } from './themeDefinitions';

export interface Props {
  /**
   * Content to show in the modal's header.
   */
  header?: React.ReactNode;
  /**
   * Content to show in the modal's subheader.
   */
  subheader?: React.ReactNode;
  /**
   * Content to show in the modal's footer.
   */
  footer?: React.ReactNode;
  /**
   * Content to show in the modal's body.
   */
  children?: React.ReactNode;
  headerId?: string;
  subheaderId?: string;
}

const ModalHeader = styled('header')(
  css({
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    bg: HeadingFill,
    p: 2,
    color: HeadingText,
    overflowWrap: 'break-word',
  }),
);

const ModalHeading = styled('h4')(
  css({ margin: 0, fontSize: 16, fontWeight: ThemeFontWeights.Bold }),
);

const ModalSubheading = styled('h5')(
  css({
    mt: 1,
    mb: 0,
    mx: 0,
    fontWeight: ThemeFontWeights.Normal,
    lineHeight: 1.3,
    color: SubHeadingText,
  }),
);

export const ModalBody = styled('div')(
  css({
    py: 3,
    px: 2,
    position: 'relative',
    overflowWrap: 'break-word',
  }),
);

export const ModalContent = ({
  header,
  subheader,
  footer,
  children,
  headerId,
  subheaderId,
}: Props) => (
  <>
    {header && (
      <ModalHeader>
        <ModalHeading id={headerId}>{header}</ModalHeading>
        {subheader && <ModalSubheading id={subheaderId}>{subheader}</ModalSubheading>}
      </ModalHeader>
    )}
    <ModalBody>{children}</ModalBody>
    {footer && (
      <Box as="footer" px={2} py={1} borderTop={1} borderColor={BodyFooterDivider}>
        {footer}
      </Box>
    )}
  </>
);
